import React, { useEffect, useState } from 'react';
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import Card from 'saur_ui_library/src/Molecules/Card/Card';
import { getInfoBulleMessage, getOptionsCommunes, getOptionsInstalls, resetImputLabel, resetOptions } from '../../../utils/helpers/module/filtersHelper';
import { colorFormated } from '../../../utils/helpers/module/moduleComponentHelper';
import DataSelector from '../../common/component/dataSelector';
import Legend from '../../common/component/Legend';
import SingleFilter from '../component/SingleFilter';
import { useLocation } from 'react-router-dom';
import { defineDefinitionExpression } from '../../../utils/helpers/map/defExpHelper';
import { loaderDataComponent } from '../../../utils/helper';

const FiltersH2s = (props: any) => {
  const contractCode = window.sessionStorage.getItem('contractCode') || '';
  // const for dropdownlist on change
  const [fonctionnement, setFonctionnement] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('h2s_color')!) || ''
  );
  const [commune, setCommune] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('h2s_commune')!) || {
      name: '',
      code: '',
    }
  );
  const [installations, setInstallations] = useState<any>(
    JSON.parse(window.sessionStorage.getItem('h2s_installation')!) || {
      name: '',
      code: '',
    }
  );
  // const for dropdownlists options
  const [communeOptions, setCommuneOptions] = useState<any>([]);
  const [installationsOptions, setInstallationsOptions] = useState<any>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [fieldNameColor, ] = useState<string>(
    props.option === 'IndicatorBoonLister' ? 'ColorBoonLister' : 
    props.option === 'IndicatorSejourCana' ? 'ColorSejourCana' : 
    props.option === 'IndicatorSejourPR' ? 'ColorSejourPR' : 
    props.option === 'IndicatorAutocurage' ? 'ColorAutocurage' : 
    'ColorTerrain'
  );
  const infoBulleMessageDataSelectorH2s = getInfoBulleMessage(props.module);

  const location = useLocation();
  // The current location.
  window.sessionStorage.setItem('location', location.pathname);
 
  // component did mount
  useEffect(() => {
    // load memory and launch table and map
    props.parentCallback({
      [fieldNameColor]: fonctionnement,
      InseeCode: commune,
      Code: installations,
    });
    setLoading(true);
    getCommune().then(() => {
      setLoading(false);
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // get communes options
  const getCommune = async () => {
    const optionsCommune = await getOptionsCommunes(
      contractCode,
      '60',
      props.module
    );
    if (optionsCommune.length === 0) {
      resetImputLabel('h2s-filtre-commune');
    }
    setCommuneOptions(optionsCommune);
  };

  // get installs options
  const getInstall = async (pFilters: any) => {
    const optionsInstalls = await getOptionsInstalls(
      defineDefinitionExpression(
        pFilters,
        'modules',
        contractCode
      ),
      '60'
    );
    if (optionsInstalls.length === 0) {
      resetImputLabel('h2s-filtre-installation');
    }
    setInstallationsOptions(optionsInstalls);
  };

  // trigger dynamic dropdownlists hence on change (commune, type and deversement)
  useEffect(() => {
    if(loading === false){
      setLoading(true);
      getInstall({
        [fieldNameColor]: colorFormated(fonctionnement),
        InseeCode: commune,
        Code: installations,
      }).then(() => {
        setLoading(false);
      });
    }
  }, [commune, installations, fonctionnement]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <Container className='filterForm'>
      <Card automatedTestId='h2s-filter'>
        <Word
          value='FILTRER MA RECHERCHE'
          textStyle='title'
          variant='h1'
          automatedTestId='search-word'
        />
        <Legend type={localStorage.getItem('type')!} option={props.option}/>
        <Container className='fonctionnement'>
          <Word
            value='Fonctionnement'
            textStyle='normalReg'
            variant='p'
            automatedTestId='id-fonctionnement'
          />
          <DataSelector
            infoBulles={infoBulleMessageDataSelectorH2s}
            sendSelectedColor={(d: any) => {
              setFonctionnement(d);
              fonctionnement !== '' &&
                props.parentCallback({
                  [fieldNameColor]: d,
                  InseeCode: commune,
                  Code: installations,
                });
              window.sessionStorage.setItem('h2s_color', JSON.stringify(d));
            }}
            type='h2s'
            sessionStorageName={'h2s_color'}
          />
        </Container>
        {commune !== null && (
          <SingleFilter
            module='h2s'
            title='Communes :'
            filterName={'commune'}
            filterOptions={communeOptions}
            parentCallback={(d) => {
              setCommune(d);
              resetOptions(
                d,
                'h2s-filtre-installation',
                setInstallationsOptions
              );
              props.parentCallback({
                [fieldNameColor]: fonctionnement,
                InseeCode: d,
                Code: {
                  name: '',
                  code: '',
                },
              });
            }}
          />
        )}
        {installations !== null && (
          <SingleFilter
            module='h2s'
            title='Installations :'
            filterName={'installation'}
            filterOptions={installationsOptions}
            parentCallback={(d) => {
              setInstallations(d);
              props.parentCallback({
                [fieldNameColor]: fonctionnement,
                InseeCode: commune,
                Code: d,
              });
            }}
          />
        )}
        {loaderDataComponent(loading)}
      </Card>
    </Container>
  );
};
export default FiltersH2s;
